// Rastro do fluxo do viewer nativo no console, com prefixo único para filtrar
// (`[coordly-3d]`): listagem → render → hub → artefatos → motor. Temporário — é
// o que permite acompanhar em HMG enquanto o backend estabiliza.
export const nativeLog = (step: string, detail?: unknown) => {
  console.info(`[coordly-3d] ${step}`, detail ?? '');
};
